import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

// Trae la lista de tipo Seguimiento
export async function listarTipoSeguimiento({state, commit}, requestParameters = {params: state.filtro}) {

    commit('dashboard/load', true, {root: true});

    await $http.get('adm_general/tipo-seguimiento', requestParameters)
        .then((response) => {
            commit('setListarTipoSeguimiento', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });

    commit('dashboard/load', false, {root: true});
}

// Crea un nuevo tipo de seguimiento
export async function crearTipoSeguimiento({commit, state}) {

    commit('dashboard/load', true, {root: true});

    await $http.post('adm_general/tipo-seguimiento/crear', state.selectedTipoSeguimiento)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true,
                timer: 5000
            });
            commit('resetSelectedTipoSeguimiento');
        })
        .catch((error) => {
            let texto = [];

            if (error.errors) {
                const errores = error.errors;
                for (const llave in errores) {
                    if (errores[llave] && errores[llave][0]) {
                        texto.push(errores[llave][0]);
                    }
                }
            }

            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                text: texto.join('\n'),
                showConfirmButton: true,
                timer: 5000
            });
        });

    commit('dashboard/load', false, {root: true});
}

// Muestra un tipo de seguimiento especifico
export async function mostrarTipoSeguimiento({commit}, id) {
    await $http.get(`adm_general/tipo-seguimiento/mostrar/${id}`).then((response) => {
        commit('setTipoSeguimiento', response.data.data);
    }).catch((error) => {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message + '<br> ' + error.errors,
            showConfirmButton: true,
            timer: 5000
        });
        commit('accionError', error.message);
    });
}

// Actualiza un tipo de seguimiento
export async function actualizarTipoSeguimiento({commit, state, dispatch}) {

    commit('dashboard/load', true, {root: true});

    await $http.put(`adm_general/tipo-seguimiento/editar/${state.selectedTipoSeguimiento.id}`, state.selectedTipoSeguimiento)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: true,
                timer: 5000
            });
            dispatch('mostrarTipoSeguimiento', state.selectedTipoSeguimiento.id);
        }).catch((error) => {
            let texto = [];

            if (error.errors) {
                const errores = error.errors;
                for (const llave in errores) {
                    if (errores[llave] && errores[llave][0]) {
                        texto.push(errores[llave][0]);
                    }
                }
            }

            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message,
                text: texto.join('\n'),
                showConfirmButton: true,
                timer: 5000
            });
        });

    commit('dashboard/load', false, {root: true});
}

// Elimina Un tipo de seguimiento
export async function desactivarTipoSeguimiento({commit, state, dispatch}, id) {

    await Swal.fire({
        title: 'Cambiar estado',
        text: '¿Está seguro de cambiar el estado del tipo de seguimiento?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si, cambiar'
    }).then(async (result) => {
        if (result.value) {

            commit('dashboard/load', true, {root: true});

            await $http.put(`adm_general/tipo-seguimiento/inactivar/${id}`)
                .then((response) => {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien!',
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 5000
                    });
                    dispatch('listarTipoSeguimiento');
                    state.error = false;
                }).catch((error) => {
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: error.message + '<br> ' + error.errors,
                        showConfirmButton: true,
                        timer: 5000
                    });
                    commit('accionError', error.message);
                });

            commit('dashboard/load', false, {root: true});
        }
    });
}

// filtro de paginacion
export function setPagePagination({commit, dispatch}, page) {
    commit('setPage', parseInt(page));
    dispatch('listarTipoSeguimiento');
}
